import Page from '@app/components/layout/page/page';
import PurchasedFoodAndDrinkItemForm from '../components/item/purchased-food-and-drink-item-form';
import { usePurchasedFoodAndDrinkItem } from '../purchased-food-and-drink-item-context';

export default function PurchasedFoodAndDrinkItemPage() {
  const { item, status } = usePurchasedFoodAndDrinkItem();
  return (
    <Page name="Food and drink" page="subpage" status={status} flexFullHeight>
      <PurchasedFoodAndDrinkItemForm item={item} />
    </Page>
  );
}
